export default __webpack_public_path__ + "images/2f1c77eacdd5931172f748329c2cb8ea-adoption-center-banner-text-667.png";